import {
  Box,
  Button,
  HeadingText,
  ParagraphText,
  StackLayout,
  TextAction,
} from '@leagueplatform/genesis-core';
import { BasePage } from 'components/base-page/base-page.component';
import allSetIllustration from 'assets/all-set-illustration.svg';

export const AllSet = ({
  onGetStartedClick,
  onNotNowClick,
}: {
  onGetStartedClick: () => void;
  onNotNowClick: () => void;
}) => (
  <BasePage
    isPrivatePage={false}
    css={{
      background: '$surfaceBackgroundSecondary',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '$two',
    }}
  >
    <Box
      css={{
        width: '708px',
        maxWidth: '100%',
        marginInline: 'auto',
        background: '$surfaceCardSecondary',
        boxShadow: '$card',
        borderRadius: '$medium',
      }}
    >
      <StackLayout
        spacing="$twoAndHalf"
        horizontalAlignment="stretch"
        css={{
          paddingBlock: '$twoAndHalf',
          paddingInline: '$twoAndHalf',
        }}
      >
        <Box
          as="img"
          src={allSetIllustration}
          alt=""
          width={176}
          height={176}
          css={{ display: 'block', marginInline: 'auto' }}
        />

        <StackLayout spacing="$half" horizontalAlignment="center">
          <HeadingText
            size="lg"
            level="2"
            as="h1"
            css={{ textAlign: 'center' }}
          >
            You&apos;re all set
          </HeadingText>
          <ParagraphText
            css={{ textAlign: 'center', color: '$onSurfaceTextSubdued' }}
          >
            If you&apos;d like to personalize your experience even more,
            complete your health assessment. It&apos;s not required, but it does
            help us tailor your journey just for you.
          </ParagraphText>
        </StackLayout>

        <StackLayout spacing="$oneAndHalf" horizontalAlignment="center">
          <Button
            type="button"
            size="large"
            priority="primary"
            width="fillContainer"
            onClick={onGetStartedClick}
          >
            Start health assessment
          </Button>
          <TextAction
            as="button"
            type="button"
            size="large"
            onClick={onNotNowClick}
          >
            Not now
          </TextAction>
        </StackLayout>
      </StackLayout>
    </Box>
  </BasePage>
);
